export enum QualityType {
  Default = '',
  Pass = 'Pass',
  Fail = 'Fail',
  Hold = 'Hold',
  Unknown = 'Unknown',
}
